// extracted by mini-css-extract-plugin
export default {"main":"EmailBody_main__qeJKj"};